<template>
  <div class="page-learn-ability-test-begin-page">
    <start-header type="start" />
    <div class="page-learn-ability-test-begin-page-input-block user-name">
      <img :src="require('@/pages/2020/LearnAbilityTest/assets/img/name_icon.png')"
           alt=""
      />
      <ym-field class="ym-field"
                v-model.trim="userName"
                placeholder="填写昵称"
                model="whole-line"
      />
    </div>
    <div class="page-learn-ability-test-begin-page-input-block age">
      <img :src="require('@/pages/2020/LearnAbilityTest/assets/img/age_icon.png')"
           alt=""
      />
      <ym-field class="ym-field"
                v-model.trim="age"
                type="tel"
                maxlength="2"
                placeholder="填写孩子年龄"
                model="whole-line"
      />
    </div>
    <div class="page-learn-ability-test-begin-page-submit-btn"
         @click="handleBeginTest"
         v-ym-report:MARKETING_LEARNABILITYTEST_START_CLICK
    >
      开始测试
    </div>
  </div>
</template>

<script>
  import { Field } from '@ymba/ym-ui';
  import Header from '@/pages/2020/LearnAbilityTest/components/Header';

  export default {
    name: 'LearnAbilityTestBeginPage',
    components: {
      'ym-field': Field,
      'start-header': Header,
    },
    data() {
      return {
        userName: '',
        age: '',
      };
    },
    methods: {
      handleBeginTest() {
        if (this.userName === '') {
          this.$toast('请填写孩子姓名');
          return;
        }
        if (this.age === '') {
          this.$toast('请填写孩子年龄');
          return;
        }
        this.$emit('show-test-page', { userName: this.userName, age: this.age });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-learn-ability-test-begin-page {
    height: 100%;
    background: #242648;

    &-content {
      margin-top: 40px;
      color: @color-white;
      font-size: 28px;
      text-align: center;
      line-height: 1.6;

      &-desc {
        font-size: 32px;
        font-weight: @font-weight-primary;
      }
    }

    &-input-block {
      margin: 0 auto 30px;
      width: 500px;
      height: 100px;
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: @color-white;
      /deep/ .ym-field-model--whole-line {
        height: 100px;

        input {
          padding-top: 0;
        }
      }

      &.user-name {
        margin-top: 200px;
        img {
          margin-right: 34px;
          display: block;
          width: 50px;
          height: 50px;
        }
      }
      &.age {
        img {
          margin-right: 34px;
          display: block;
          width: 44px;
          height: 44px;
        }
      }
    }

    &-submit-btn {
      margin: 60px auto 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 400px;
      height: 100px;
      color: #242648;
      font-size: 36px;
      font-weight: bold;
      background: linear-gradient(0deg, #ffdf30, #fff176);
      box-shadow: 0 8px 12px 0 rgba(16, 18, 53, 0.4);
      border-radius: 50px;
    }
  }

</style>
